export const menuAdminCliente = [
  { label: "Coordenadores", path: "/coordenadores" },
  { label: "Professores", path: "/professores" },
  { label: "Cursos", path: "/cursos" },
  { label: "Disciplinas", path: "/disciplinas" },
  { label: "Turmas", path: "/turmas" },
  { label: "CheckPoints", path: "/autorizar-checkpoints" },
  { label: "Gestão Financeira", path: "/financeira" },
  { label: "Meus Dados", path: "/meus-dados" }];
